import Axios from '../baseApi';

export default {
  async fetch(id) {
    return await Axios.get(`/api-master-data/addition-account/v1/${id}`);
  },
  async update(form) {
    return await Axios.post(`/api-master-data/addition-account/v1`, form);
  }
}
